import React, { Component, Fragment } from 'react';

import * as Func from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT } from '../../../../../../constants/Define';
import { getMomentDate } from '../../../../../../utils/commonUtils';
import {
    FormWrapperItem, ListComponent, StatusComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import { Collapse, Skeleton } from 'antd';
import Order, { SmsHistory } from '../../../../../../models/Order';
import { Tooltip, Icon } from 'antd';
import telegramPlane from '../../../../../../assets/images/telegram-plane.svg';

import './SmsHistories.less';

const { Panel } = Collapse;

const removedColumns = [
    'id', 'orderId', 'shortCode', 'createdBy',
];
const OrderVinWonderItemKeys = Object.getOwnPropertyNames(new SmsHistory());
export default class SmsHistories extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(['index', ...OrderVinWonderItemKeys, 'action'], [], removedColumns),
            modelItem: OrderVinWonderItemKeys,
            componentTable: {
                index: {
                    align: 'center',
                    render: (date, record, index) => index + 1
                },
                receivers: {
                    width: 130,
                },
                createdDate: {
                    render: (date, record) => {
                    return date && <div>{getMomentDate(date).format(DATE_TIME_FORMAT.FULL_DATE_TIME)}</div>
                    }
                },
                status: {
                    key: 'status',
                    width: 100,
                    render: (value, record) => {
                        return <Fragment>
                            <StatusComponent color={value ? 'green' : 'red'}
                                label={this.props.t(value ? `item.order.orderSmsHistories.statusTypes.Success` : `item.order.orderSmsHistories.statusTypes.Failed`)} />
                        </Fragment>
                    },
                },
                action: {
                    width: 100,
                    align: 'center',
                    render: (text, record) => <Fragment>
                        <Tooltip title={this.props.t(`item.order.orderSmsHistories.action`)} placement="top">
                            <img src={telegramPlane} width={20} className="cursorPointer" onClick={() => this.onClickResendSMS(record)} />
                        </Tooltip>
                    </Fragment>
                }
            }
        };
    }

    render() {
        const { t, smsHistories, loading } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        
        return (
                <Collapse className='my-3 w-100' style={{backgroundColor: "white"}} bordered={false} expandIconPosition='right'>
                    <Panel header={
                        <h3 className={`m-0`} style={{color:"#676a6c"}}>{t('item.order.smsHistories')}</h3>
                    } key="1">
                        <Wrapper className="col-md-12 sms-histories-section">
                            <Wrapper className={`row mt-2 mb-3`}>
                                <FormWrapperItem classParent="p-0" classChildren="m-0 p-0">
                                    {!loading ?
                                        <ListComponent
                                            classParent="m-0 p-0 col-md-12"
                                            marginTop={'0'} marginBottom={'0'}
                                            loading={{ spinning: loading, size: 'large' }}
                                            rowKey={(record, k) => k}
                                            dataSource={Func.getDataSource(smsHistories, modelItem)}
                                            columns={Func.columnsTable({
                                                titleTable: titleItemTable,
                                                component: componentTable,
                                                itemName: 'order.orderSmsHistories'
                                            })}
                                            componentTableList={{}}
                                            hideSettings={true}
                                        />
                                        : <Skeleton active paragraph={{ row: 3 }} className="p-4" />
                                    }
                                </FormWrapperItem>
                            </Wrapper>
                        </Wrapper>
                    </Panel>
                </Collapse>

        );
    }

    onClickResendSMS = (item) => {
        this.props.onResendSms(item.id, item.orderId);
    }
}

SmsHistories.defaultProps = {
    smsHistories: [],
    loading: false,
};